/*
Sohel 01/23/2023 2698964415 Search Table Changes
Sohel 01/23/2023 2698964415 Added Audit Fields in fields
Sohel 01/23/2023 2698964415 disabled fields
Sohel 02/21/2023 2698964415 Audit Field List Changes
suresh peddavoora 03/06/2023 2698964415 textfield alignments fixes

*/
import React, {createRef, useState, useEffect} from 'react';
import {TablePagination, Grid} from '@material-ui/core';
import {tableIcons} from '../../../../../../components/TableIcons';
import GuiTable from '../../../../../../components/FormComponents/GuiTable';
import {defaultRows} from '../../../../../../constants/ReusableTablePagination';
import {tablePageRows} from '../../../../../../constants/ReusableConstants';
import {httpPaginationPost} from '../../../../../../util/Rest';
import {useDispatch} from 'react-redux';

function SearchDMRecordTable({
  searchData,
  submit,
  setSubmit,
  dmValues,
  setTempSelectedRows,
  tempSelectedRows,
  tempUnCheckedRef,
  isRecordFormat = false,
}) {
  const tableRef = createRef();
  const [rows, setRows] = useState(defaultRows);
  const [arrayLast, setArrayLast] = useState(false);
  const dispatch = useDispatch();

  const columns = [
    {
      title: 'Category',
      render: (rowData) => {
        return rowData?.category === 'CL' ?
        `CL - Client` :
          rowData?.category === 'CO' ?
        `CO - Core` :
            '';
      },
      width: '1%',
    },
    {
      title: 'Field Type',
      field: 'fieldType',
    },
    {
      title: 'Repository Name',
      field: 'repositoryName',
    },
    {
      title: 'Field Name',
      field: 'fieldName',
    },
  ];

  useEffect(() => {
    if (tableRef?.current && submit) {
      Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : '';
    }
  }, [submit]);
  return (
    <>
      <Grid item xs={12}>
        <div className="custom-table global-field-table custom-toolbar-icons custom-actions-icon new-standard-textfields">
          <GuiTable
            title={''}
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            onSelectionChange={(rows, row) => {
              if (row?.tableData?.checked) {
                if (tempSelectedRows && !isRecordFormat) {
                  const arr = [...tempSelectedRows].filter((el) => el.tableData.checked);
                  arr.push({
                    ...row,
                    processorFieldType: 'Audit Field',
                    dataType: row.fieldType,
                    tableData: {
                      ...row.tableData,
                      id: row.fieldName + row.repositoryName,
                    },
                  });
                  setTempSelectedRows(arr);
                }
                if (tempSelectedRows && isRecordFormat) {
                  const arr = [...tempSelectedRows].filter((el) => el.tableData.checked);
                  arr.push({
                    ...row,
                    tableData: {...row.tableData, id: row.fieldName + row.repositoryName},
                    mapFieldType: 'Audit Field',
                    fieldHeader: row.fieldName,
                    fieldPosition: '',
                    startPosition: '',
                    fieldLength: '',
                    format: '',
                    dataType: row.fieldType,
                  });
                  setTempSelectedRows(arr);
                }
              } else {
                tempUnCheckedRef.current.push(row);
                if (isRecordFormat) {
                  const updatedRows = [...tempSelectedRows]
                    .filter(
                      (ele) =>
                        ele?.fieldName + ele?.repositoryName + ele?.mapFieldType !==
                        row?.fieldName + row?.repositoryName + row?.mapFieldType,
                    )
                    .map((ele) => {
                      return {
                        ...ele,
                        tableData: {
                          ...ele.tableData,
                          id: ele.fieldName + ele?.repositoryName,
                        },
                      };
                    });
                  setTempSelectedRows(updatedRows);
                } else {
                  const updatedRows = [...tempSelectedRows]
                    .filter(
                      (ele) =>
                        ele?.fieldName + ele?.repositoryName + ele?.processorFieldType !==
                        row?.fieldName + row?.repositoryName + row?.mapFieldType,
                    )
                    .map((ele) => {
                      return {
                        ...ele,
                        tableData: {
                          ...ele.tableData,
                          id: ele.fieldName + ele?.repositoryName,
                        },
                      };
                    });
                  setTempSelectedRows(updatedRows);
                }
              }
            }}
            data={(query) =>
              new Promise((resolve) => {
                const url = `globalfield/getall/auditfields`;
                const bodyObj = {
                  category: searchData?.category?.categoryCode ?
                    searchData?.category?.categoryCode :
                    '',
                  fieldName: searchData?.fieldName ? searchData?.fieldName : '',
                  fieldType: searchData?.fieldType ? searchData?.fieldType : '',
                  limit: query?.pageSize ? query?.pageSize : null,
                  orderDirection: query?.orderDirection ? query?.orderDirection : '',
                  orderBy: query?.orderBy && query?.orderBy?.field ? query?.orderBy?.field : '',
                  page: submit ?
                    1 :
                    arrayLast && query?.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                  repositoryName: searchData?.repositoryName ? searchData?.repositoryName : '',
                };

                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const data = response.data.response.resultObjects;
                        const newObj = {};
                        if (isRecordFormat && dmValues) {
                          [...dmValues.selectedFields, ...tempSelectedRows].forEach((el) => {
                            if (!newObj[el.fieldName + el.repositoryName + el.mapFieldType]) {
                              newObj[el.fieldName + el.repositoryName + el.mapFieldType] = el;
                            }
                          });
                        } else {
                          [...dmValues.selectedFields, ...tempSelectedRows].forEach((el) => {
                            if (!newObj[el.fieldName + el.repositoryName + el.processorFieldType]) {
                              newObj[el.fieldName + el.repositoryName + el.processorFieldType] = el;
                            }
                          });
                        }
                        const newData = data?.map((el) => {
                          return {
                            ...el,
                            mapFieldType: 'Audit Field',
                            processorFieldType: 'Audit Field',
                          };
                        });
                        const newRows = newData?.map((elem) => {
                          if (newObj[elem.fieldName + elem.repositoryName + elem.mapFieldType]) {
                            return {...elem, tableData: {...elem.tableData, checked: true}};
                          } else {
                            return {
                              ...elem,
                              tableData: {...elem.tableData, checked: false},
                            };
                          }
                        });
                        resolve({
                          data: newRows?.length > 0 ? newRows : data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setArrayLast(data.length === 1);
                        setSubmit(false);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            options={{
              search: false,
              pageSize: rows,
              toolbar: false,
              toolbarButtonAlignment: 'left',
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              selectionProps: (rowData) => {
                let disabledFields = false;
                const checked = rowData?.active === 'no' ? {checked: false} : {};
                dmValues?.selectedFields?.forEach((el) => {
                  if (
                    el.repositoryName?.concat(el.fieldName)?.concat(el?.fieldType) ===
                      rowData.repositoryName?.concat(rowData?.fieldName)?.concat(rowData?.mapFieldType) &&
                    (el?.tabType === 'Record Format Field' || el?.isEditable === false)
                  ) {
                    disabledFields = true;
                  }
                });
                return {
                  disabled: disabledFields,
                  ...checked,
                };
              },
              selection: true,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer">
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: {'aria-label': 'Rows per screen'},
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              ),
            }}
          />
        </div>
      </Grid>
    </>
  );
}

export default SearchDMRecordTable;
